import {
  clearFlagsFromFlagsManager,
  maybeDispatchContentIdChanged,
  rebuildFieldTypesConfig,
} from '@databases/core-event-bus/listeners';
import { rebuildFieldTypesConfig as rebuildFieldsConfig } from '@databases/fields';
import { container } from '@databases/service-container';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

/**
 * Register core event listeners. This should be invoked early on in the bootstrapping of the application.
 */
function registerCoreEventListeners() {
  const eventBus = container.resolve('EventBus');

  eventBus.on('bridgeDataChanged', maybeDispatchContentIdChanged(eventBus));
  eventBus.on('databaseContentIdChanged', () => {
    clearFlagsFromFlagsManager(container.resolve('FlagsManager'));
    // clear selection on content id change
    waitForContentAPI().then((contentAPI) => {
      contentAPI?.publishDatabaseReferencingContent?.([]);
    });
  });
  eventBus.on('featureFlagsChanged', rebuildFieldTypesConfig(rebuildFieldsConfig));
}

export { registerCoreEventListeners };
